// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FzEn","type":"styles_type__26wb9","choices":"styles_choices__20_Lk"};